import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { tv, VariantProps } from 'tailwind-variants'

const alertMessageVariants = tv({
  base: 'flex w-full gap-2 rounded-lg border p-2 text-xs md:p-4 md:text-sm',
  variants: {
    variant: {
      warning: 'border-alert-warning bg-alert-warning/5 text-monochromatic-500',
    },
  },
  defaultVariants: {
    variant: 'warning',
  },
})
interface AlertMessageProps
  extends ComponentProps<'div'>,
    VariantProps<typeof alertMessageVariants> {}

function alertMessageRoot({ className, variant, ...rest }: AlertMessageProps) {
  return (
    <div className={alertMessageVariants({ variant, className })} {...rest} />
  )
}

const alertMessageIconVariants = tv({
  base: '',
  variants: {
    variant: {
      warning: 'text-alert-warning',
    },
    size: {
      default: '*:size-5',
      small: '*:size-4',
      large: '*:size-8',
    },
  },
  defaultVariants: {
    variant: 'warning',
    size: 'default',
  },
})

interface AlertMessageIconProps
  extends ComponentProps<'div'>,
    VariantProps<typeof alertMessageIconVariants> {}
function alertMessageIcon({
  className,
  size,
  variant,
  ...rest
}: AlertMessageIconProps) {
  return (
    <div
      className={alertMessageIconVariants({ className, variant, size })}
      {...rest}
    />
  )
}

interface AlertMessageDescriptionProps extends ComponentProps<'p'> {}
function alertMessageDescription({
  className,
  ...rest
}: AlertMessageDescriptionProps) {
  return <p className={twMerge('', className)} {...rest} />
}

interface AlertMessageDescriptionBold extends ComponentProps<'span'> {}
function alertMessageDescriptionBold({
  className,
  ...rest
}: AlertMessageDescriptionBold) {
  return <span className={twMerge('font-bold', className)} {...rest} />
}
export const AlertMessage = {
  Root: alertMessageRoot,
  Prefix: alertMessageIcon,
  DescriptionRoot: alertMessageDescription,
  DescriptionBold: alertMessageDescriptionBold,
}
